<!-- Esquerda: menu + logo (no horizontal o botão vem depois do logo) -->
<div class="flex items-center gap-[0.75rem]">
  <!-- Esquerda: botão de menu antes do logo no vertical (inclui mobile) -->
  @if (navegacao.layoutEfetivo() === 'vertical') {
    <button
      app-button
      type="button"
      cor="highlight"
      variante="ghost"
      tamanho="lg"
      quadrado
      icone="menu"
      [attr.aria-label]="rotuloMenu()"
      [attr.aria-expanded]="expandidoMenu()"
      (click)="aoClicarMenu()"
    ></button>
  }

  <a
    routerLink="/dashboard"
    aria-label="R.fy – início"
    class="flex items-center gap-1.5 text-[1.375rem] font-bold leading-none tracking-[-0.02em] text-rfy-foreground-strong no-underline hover:text-rfy-foreground-strong"
  >
    <svg width="16" height="18" viewBox="0 0 16 18" aria-hidden="true">
      <path d="M0 9 16 0v18z" class="fill-rfy-primary" />
    </svg>
    <span>R<span class="font-normal">.fy</span></span>
  </a>

  <!-- Esquerda: botão de menu depois do logo no horizontal -->
  @if (navegacao.layoutEfetivo() === 'horizontal') {
    <button
      app-button
      type="button"
      cor="highlight"
      variante="ghost"
      tamanho="lg"
      quadrado
      icone="menu"
      [attr.aria-label]="rotuloMenu()"
      [attr.aria-expanded]="expandidoMenu()"
      (click)="aoClicarMenu()"
    ></button>
  }
</div>

<!-- Direita: ações e perfil -->
<div class="flex items-center gap-1">
  <a
    app-button
    cor="highlight"
    variante="ghost"
    tamanho="lg"
    quadrado
    icone="calendario"
    routerLink="/agenda"
    aria-label="Agenda"
  ></a>

  <button
    app-button
    type="button"
    cor="highlight"
    variante="ghost"
    tamanho="lg"
    quadrado
    icone="notificacoes"
    desabilitado
    aria-label="Notificações (em breve)"
  ></button>

  <button
    app-button
    type="button"
    cor="highlight"
    variante="ghost"
    tamanho="lg"
    quadrado
    icone="configuracoes"
    [attr.aria-expanded]="navegacao.configAberta()"
    aria-label="Configurações"
    (click)="navegacao.alternarConfig()"
  ></button>

  <span aria-hidden="true" class="mx-[0.5rem] h-7 w-px bg-rfy-border-strong"></span>

  <app-menu rotulo="Menu do usuário" posicao="baixo-fim">
    <button
      appMenuGatilho
      type="button"
      class="flex items-center gap-2.5 rounded-controle px-[0.375rem] py-[0.25rem] bg-[transparent] border-solid border-[0px] text-rfy-foreground hover:bg-rfy-subtle cursor-pointer"
    >
      <app-avatar variante="suave" tamanho="md" [nome]="nomeCompleto" [foto]="foto" />
      <span class="hidden min-[769px]:flex flex-col leading-tight text-left">
        <span class="text-sm font-semibold">{{ nomeCompleto }}</span>
        <span class="text-xs text-rfy-highlight">{{ email }}</span>
      </span>
    </button>

    <a app-menu-item icone="usuario" routerLink="/perfil">Perfil</a>
    <a app-menu-item icone="versoes" routerLink="/historico-versoes">Versões</a>
    <app-menu-divisor />
    <button app-menu-item type="button" icone="sair" (click)="sair()">Sair</button>
  </app-menu>
</div>
